import React from 'react';
import PropTypes from 'prop-types';
import { bem } from 'helpers/class-name';
import { parseISO } from 'date-fns';
import { reduxFormPropTypes, intlMessage } from 'constants/propTypes';
import { shouldShowError } from 'helpers/page-utils';
import InputLabel from '../InputLabel/InputLabel';
import InputError from '../InputError/InputError';
import DateControls from './DateControlsContainer';
import './DateInput.scss';

const { block, element } = bem('date-input');

const DateInput = ({ className, input: { value, onChange }, meta, disabled, label }) => {
  const hasError = shouldShowError(meta);

  return (
    <div className={block(className)}>
      <InputLabel message={label} />
      <div className={element('controls')}>
        <DateControls
          date={value ? parseISO(value) : new Date()}
          onChange={onChange}
          disabled={disabled}
          hasError={hasError}
        />
      </div>
      <InputError {...meta} />
    </div>
  );
};

DateInput.propTypes = {
  className: PropTypes.string,
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  meta: reduxFormPropTypes.field.meta,
  disabled: PropTypes.bool,
  label: intlMessage,
};

export default DateInput;
